import { FC } from 'react';
import { Alert } from './AlertInvalidationRequested.style';

const ExternalSystemInvalidationRequested: FC = () => {
    return (
        <Alert message={`This declaration has been requested to be invalidated by Revenue`} type="warning" showIcon />
    );
};
export default ExternalSystemInvalidationRequested;
